<!doctype html>
<html lang="Pt-br">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Géia</title>
    <link href="https://fonts.googleapis.com/css?family=Montserrat:200,400" rel="stylesheet" />
    <!-- Google Tag Manager -->
    <script>
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-N73Z6Q5S');
    </script>

    <!-- End Google Tag Manager -->

    <!-- Meta Pixel Code -->
    <script>
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1793476850722515');
      fbq('track', 'PageView');
    </script>
    <noscript>
      <img
        height="1"
        width="1"
        style="display: none"
        src="
  https://www.facebook.com/tr?id=1793476850722515&ev=PageView&noscript=1" />
    </noscript>
    <!-- End Meta Pixel Code -->
  </head>

  <body>
    <!-- Google Tag Manager (noscript) -->
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-N73Z6Q5S"
        height="0"
        width="0"
        style="display: none; visibility: hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
    <app-header></app-header>

    <!--====== section banner ======-->
    <section id="home" class="video-section pb-5" style="padding-bottom: 2%; background-color: #ffffff">
      <app-carrossel></app-carrossel>
    </section>

    <!--====== sect ion banner  End ======-->

    <modal-imposto-de-renda></modal-imposto-de-renda>

    <!--====== CUIDANDO DE VOCE ======-->

    <section class="about-section section-gap page-title-area page-title-bg bg-img-section img-fluid">
      <div class="cuidando-de-voce-container">
        <div class="cuidando-de-voce-about-text mt-30">
          <h3 class="cuidando-de-voce-heading-h3 mb-1 title bold-preto-400 text-center-mobile">
            <span>Para</span>
            <b>você,</b>
            sua
            <b>família</b>
            <br />
            ou
            <b>empresa.</b>
          </h3>
          <h3 class="text-center-mobile cuidando-de-voce-subtitle-h3">
            <b>
              CUIDANDO DE
              <br />
            </b>
            <b class="mt">QUEM VOCÊ AMA!</b>
          </h3>
        </div>
      </div>
    </section>

    <!--======  CUIDANDO DE VOCE  END======-->

    <!--======  SECTION NUMEROS======-->
    <section class="feature-section bg-geia-azul">
      <div class="container">
        <div class="row justify-content-center service-looop">
          <div class="col-lg-12">
            <div class="section-heading text-center mt-3">
              <h2 class="title font-rage-slogan">Você saudável e seguro, é a nossa meta!</h2>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-10">
            <div class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul" data-wow-delay="0.3s">
              <div class="icon">
                <img width="50px" src="../../../../assets/app-assets/images/icones-geia/geia-historia-branco.png" />
              </div>
              <h2 class="title-geia text-white">
                +24 ANOS DE
                <br />
                HISTÓRIA
              </h2>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-10">
            <div class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
              <div class="icon">
                <!--   -->
                <img
                  class="cursor-pointer"
                  width="50px"
                  src="../../../../assets/app-assets/images/icones-geia/clientes-branco.png" />
              </div>
              <h4 class="title-geia text-white">
                +30 MIL
                <br />
                CLIENTES
              </h4>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-10">
            <div class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul" data-wow-delay="0.5s">
              <div class="icon">
                <img
                  width="50px"
                  class="cursor-pointer"
                  src="../../../../assets/app-assets/images/icones-geia/sindicatos.png" />
              </div>
              <h4 class="title-geia text-white">
                +10 ENTIDADES
                <br />
                DE CLASSE
              </h4>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-10">
            <div class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul" data-wow-delay="0.6s">
              <div class="icon">
                <img
                  width="50px"
                  class="cursor-pointer"
                  src="../../../../assets/app-assets/images/icones-geia/empresas-branco.png" />
              </div>
              <h4 class="title-geia text-white">
                +200
                <br />
                EMPRESAS
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--======  SECTION NUMEROS END======-->

    <!-- SECTION TABS -->
    <section class="doctors-section section-gap" style="padding-top: 30px !important" id="produtos-e-servicos">
      <div class="section-heading text-center mb-50">
        <!-- <span class="tagline">Atendimento personalizado,</span> -->
        <h2 class="title" style="text-transform: none; font-weight: 700; line-height: 38px">
          <i class="font-normal" style="color: #053341">Produtos</i>
          e Serviços
        </h2>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12">
            <nav>
              <ul
                class="nav nav-tabs nav-underline nav-justified"
                style="border-bottom: 0px !important; background: #f3f3f3 !important">
                <li class="nav-item">
                  <a
                    style="color: #3e6385"
                    class="title-aba nav-link active show"
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true">
                    <i class="mb-1">
                      <img src="../../../../assets/app-assets/images/icones-geia/saude.png" width="50px" />
                    </i>
                    <br />
                    PLANOS
                    <br />
                    DE SAÚDE
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    style="color: #3e6385"
                    class="nav-link show title-aba"
                    id="nav-profile-tab"
                    data-toggle="tab"
                    href="#nav-profile"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false">
                    <i class="mb-1">
                      <img src="../../../../assets/app-assets/images/icones-geia/odonto.png" width="50px" />
                    </i>
                    <br />
                    PLANOS
                    <br />
                    ODONTOLÓGICOS
                  </a>
                </li>
                <li class="container-fluid nav-item">
                  <a
                    style="color: #3e6385"
                    class="nav-link title-aba"
                    id="nav-contact-tab"
                    data-toggle="tab"
                    href="#nav-contact"
                    role="tab"
                    aria-controls="nav-contact"
                    aria-selected="false">
                    <i class="mb-1">
                      <img src="../../../../assets/app-assets/images/icones-geia/seguro.png" width="50px" />
                    </i>
                    <br />
                    SEGUROS
                  </a>
                </li>
                <li class="container-fluid nav-item">
                  <a
                    style="color: #3e6385"
                    class="title-aba nav-link"
                    id="nav-about-tab"
                    data-toggle="tab"
                    href="#nav-about"
                    role="tab"
                    aria-controls="nav-about"
                    aria-selected="false">
                    <i class="mb-1">
                      <img src="../../../../assets/app-assets/images/icones-geia/gestao-saude.png" width="50px" />
                    </i>
                    <br />
                    GESTÃO
                    <br />
                    DE SAÚDE
                  </a>
                </li>
              </ul>
            </nav>
            <!-- py-3 px-3 px-sm-0 -->
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <!-- PLANO DE SAUDE -->
                <div class="container">
                  <div class="row justify-content-center">
                    <div class="col-lg-7 col-md-10">
                      <div class="section-heading text-center mb-40">
                        <span class="text-tabs mt-4">
                          Os melhores
                          <i class="font-normal">planos de saúde regionais</i>
                          <br />
                          e nacionais com ampla rede credenciada
                          <br />
                          de clínicas, hospitais e profissionais.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container-fluid fluid-100">
                  <div class="row justify-content-center custom-service-grid">
                    <div class="container">
                      <div class="row">
                        <div id="carousel" class="carousel slide" data-ride="carousel">
                          <div class="carousel-inner">
                            <div class="carousel-item active">
                              <div class=" ">
                                <div class="slide-box">
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/bradesco-saude.png"
                                    alt="First slide" />
                                  <!-- <img class="img-w" src="../../../../assets/app-assets/images/logos-empresas/sfv.png"
                                  alt="First slide" /> -->
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/notredame.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    sclass="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/amil.png"
                                    alt="First slide" />
                                </div>
                              </div>
                            </div>
                            <div class="carousel-item">
                              <div class=" ">
                                <div class="slide-box">
                                  <img
                                    class="img-w"
                                    sclass="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/unimedfesp.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/prevent.png"
                                    alt="First slide" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <a class="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                          </a>
                          <a class="carousel-control-next" href="#carousel" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-lg-4 col-md-6">
										<div class="cta-boxed-two blend-mode-multiply mb-30">
											<button (click)="saibaMaisGeia()" type="button"
												class="btn btn-block border-radius btn-outline-info btn-min-width box-shadow-3 mr-1 mb-1">
												<i class="fa fa-plus"></i> SAIBA MAIS
											</button>
										</div>
									</div> -->
                  </div>
                </div>
                <!-- PLANO DE SAUDE -->
              </div>

              <!-- ODONTO-->
              <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                <div class="container">
                  <div class="row justify-content-center">
                    <div class="col-lg-7 col-md-10">
                      <div class="section-heading text-center mb-40">
                        <span class="text-tabs mt-4">
                          As melhores operadoras de
                          <b>planos odontológicos</b>
                          <br />
                          oferecendo ampla rede de cirurgiões, dentistas
                          <br />
                          e clínicas especializadas.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container-fluid fluid-100">
                  <div class="row justify-content-center custom-service-grid">
                    <div class="container">
                      <div class="row">
                        <div id="carousel-planos" class="carousel slide" data-ride="carousel">
                          <!-- <ol class="carousel-indicators">
                          <li data-target="#carousel-planos" data-slide-to="0" class="active"></li>
                          <li data-target="#carousel-planos" data-slide-to="1"></li>
                        </ol> -->
                          <div class="carousel-inner">
                            <div class="carousel-item active">
                              <div class=" ">
                                <div class="slide-box">
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/amil-dental.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/unimedodonto.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/uniodonto.png"
                                    alt="First slide" />
                                </div>
                              </div>
                            </div>
                            <div class="carousel-item">
                              <div class=" ">
                                <div class="slide-box">
                                  <img
                                    style="margin-left: 31%"
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/bradesco-dental.png"
                                    alt="First slide" />
                                  <img
                                    style="margin-right: 30%"
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/odontoprev.png"
                                    alt="First slide" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <a class="carousel-control-prev" href="#carousel-planos" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                          </a>
                          <a class="carousel-control-next" href="#carousel-planos" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                          </a>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="col-lg-4 col-md-6">
										<div class="cta-boxed-two blend-mode-multiply mb-30">
											<button type="button"
												class="btn btn-block border-radius btn-outline-info btn-min-width box-shadow-3 mr-1 mb-1">
												<i class="fa fa-plus"></i> SAIBA MAIS
											</button>
										</div>
									</div> -->
                  </div>
                </div>
              </div>
              <!-- ODONTO END -->
              <!-- SEGUROS -->
              <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                <div class="container">
                  <div class="row justify-content-center">
                    <div class="col-lg-7 col-md-10">
                      <div class="section-heading text-center mb-40">
                        <span class="text-tabs mt-4">
                          Para você ou sua empresa, coberturas de
                          <br />
                          assistências e serviços completas e acessíveis com as
                          <b>melhores seguradoras.</b>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container-fluid fluid-100">
                  <div class="row justify-content-center custom-service-grid">
                    <div class="container">
                      <div class="row">
                        <div id="carousel-seguros" class="carousel slide" data-interval="false">
                          <div class="carousel-inner">
                            <div class="carousel-item active">
                              <div class="d-none d-lg-block d-md-block">
                                <div class="slide-box slider-box-pading">
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/bradesco-seguro.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/sul-america.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/porto-seguro.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/sushai.png"
                                    alt="First slide" />
                                </div>
                              </div>

                              <div class="d-block d-sm-block d-md-none d-lg-none">
                                <div class="slide-box" style="display: -webkit-inline-box; margin-top: -23px">
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/bradesco-seguro.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/sul-america.png"
                                    alt="First slide" />

                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/porto-seguro.png"
                                    alt="First slide" />
                                  <img
                                    style="margin-top: -3rem; margin-left: 86px"
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/sushai.png"
                                    alt="First slide" />
                                </div>
                              </div>
                            </div>

                            <div class="carousel-item">
                              <div class="d-none d-lg-block d-md-block">
                                <div class="slide-box slider-box-pading">
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/azul-seguros.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/tokio-marine.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/mapfre.png"
                                    alt="First slide" />
                                </div>
                              </div>

                              <div class="d-block d-sm-block d-md-none d-lg-none">
                                <div class="slide-box" style="display: -webkit-inline-box; margin-top: -23px">
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/azul-seguros.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/tokio-marine.png"
                                    alt="First slide" />
                                  <img
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/mapfre.png"
                                    alt="First slide" />

                                  <img
                                    style="margin-top: -3rem; margin-left: 86px; visibility: hidden"
                                    class="img-w"
                                    src="../../../../assets/app-assets/images/logos-empresas/sushai.png"
                                    alt="First slide" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <a class="carousel-control-prev" href="#carousel-seguros" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                          </a>
                          <a class="carousel-control-next" href="#carousel-seguros" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                          </a>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="col-lg-4 col-md-6">
										<div class="cta-boxed-two blend-mode-multiply mb-30">
											<button type="button"
												class="btn btn-block border-radius btn-outline-info btn-min-width box-shadow-3 mr-1 mb-1">
												<i class="fa fa-plus"></i> SAIBA MAIS
											</button>
										</div>
									</div> -->
                  </div>
                </div>
              </div>
              <!-- SEGUROS END -->
              <div class="tab-pane fade" id="nav-about" role="tabpanel" aria-labelledby="nav-about-tab">
                <!-- GESTAO SAUDE  -->
                <div class="container-fluid fluid-100">
                  <div class="row justify-content-center">
                    <div class="col-lg-7 col-md-10">
                      <div class="section-heading text-center mb-40">
                        <span class="text-tabs mt-4">
                          Gerenciamento de risco
                          <br />
                          Consultoria especializada
                          <br />
                          Programa de Saúde
                          <br />
                          Conteúdos de saúde, bem-estar e alimentação
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container-fluid fluid-100">
                  <div class="row col-md-12 justify-content-center custom-service-grid"></div>
                </div>
                <!-- PLANO DE SAUDE -->
                <!-- ABA GEIA EMPRESAS END -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="bg-geia-azul section-gap mt-secion-familia-on-mobile"
      style="padding-top: 0px !important; text-align: -webkit-center !important">
      <div class="row container container-fluid">
        <div
          class="col-sm-6 col-md-6 d-none d-sm-none d-md-block d-lg-block"
          style="
            background-image: url(../../../../assets/app-assets/images/fotografias/banner-section-familia.png);
            background-size: cover;
            background-position: center;
          "></div>
        <div class="col-sm-6 col-md-6" style="text-align: left">
          <div class="section-heading heading-white mb-2">
            <h2
              class="title-left coletivo-adesao-h2 text-bold-600 title-color-azul mt-2"
              style="font-weight: 600 !important">
              PARA VOCÊ
            </h2>
            <h2 class="title-left coletivo-adesao-h2 text-bold-600 text-white" style="font-weight: 700">
              E SUA FAMÍLIA
            </h2>
            <p class="mt-1 title-color-azul mb-1" style="font-weight: 400; color: #053341">
              Produtos e serviços para pessoa física de:
              <b>planos de saúde, planos odontológicos e seguros.</b>
            </p>
            <a href="https://geia.com.br/#/portal" target="_blank">
              <button
                type="button"
                class="btn-min-width box-shadow-5 text-white btn mr-1 btn-lg"
                style="background: #023341">
                <i class="fa fa-shopping-cart mr-1 text-white"></i>
                <b>PORTAL DE VENDAS</b>
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- PARA VOCE E SUA FAMILIA 2  -->
    <!--====== A Geia - EMPRESAS ======-->
    <section
      id="geia-empresa"
      class="help-section bg-color-grey border-top-primary"
      style="margin-top: -130px !important">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-10 col-sm-12 col-lg-10">
            <div class="section-heading text-center mb-40">
              <div class="cta-boxed-two blend-mode-multiply mb-30">
                <!-- A GEIA -->
                <div class="section-heading mb-20">
                  <div style="text-align: center">
                    <div class="icon mb-1">
                      <div
                        data-wow-delay="0.5s"
                        class="single-img wow fadeInLeft"
                        style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInLeft">
                        <img
                          style="opacity: 0.2"
                          width="80px !important"
                          src="../../../../assets/app-assets/images/icones-geia/empresas.png"
                          alt="Image" />
                      </div>
                    </div>
                  </div>
                  <div style="margin-top: -95px !important">
                    <h2 class="title-banner h2-bold-500">Géia</h2>
                    <h2 class="sub-title-banner" style="text-transform: none; font-weight: 700; line-height: 26px">
                      Empresas
                    </h2>
                  </div>
                </div>
                <!-- A GEIA END -->
              </div>
            </div>
          </div>
        </div>
        <div class="grid-hover row isDesktop" style="margin-top: -4% !important">
          <div class="col-md-6 col-12 col-rem-pading">
            <figure class="effect-oscar">
              <img
                class="d-none d-sm-none d-md-block"
                src="../../../../assets/app-assets/images/fotografias/business-people-walking-outside-office-building.png"
                alt="Image" />
              <figcaption>
                <div id="accordionWrap01" role="tablist" aria-multiselectable="true">
                  <div data-appear="appear" class="card collapse-icon accordion-icon-rotate zoomIn">
                    <div id="heading01" class="card-header">
                      <a
                        data-toggle="collapse"
                        data-parent="#accordionWrap01"
                        href="#accordion01"
                        aria-expanded="false"
                        aria-controls="accordion14"
                        class="card-title collapseAnimation lead collapsed title-acordion"
                        data-animation="pulse">
                        <i class="mr-1">
                          <img
                            src="../../../../assets/app-assets/images/icones-geia/seguro-corporativo.png"
                            width="40px" />
                        </i>
                        SEGUROS CORPORATIVOS
                      </a>
                    </div>
                    <div
                      id="accordion01"
                      role="tabpanel"
                      aria-labelledby="heading01"
                      class="collapse"
                      aria-expanded="false">
                      <div class="card-content">
                        <div class="card-body title-a-geia">
                          <p class="text-justify mb-2" style="line-height: 157%">
                            <b class="geia-secundary">Prevenimos e asseguramos</b>
                            que o seu negócio esteja protegido caso haja sinistro, garantindo a reposição de acordo com
                            o que foi contratado. Esse é o nosso compromisso, oferecendo vasta gama de serviços, como:
                            Riscos Patrimoniais, Seguro Frota, Cyber Risks, Seguros Linhas Financeiras, Seguro de
                            Transporte Multi Modal, entre outros.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </figcaption>
            </figure>
          </div>
          <div class="col-md-6 col-12" style="padding-right: 0px; padding-left: 0px">
            <figure class="effect-oscar">
              <img
                class="d-none d-sm-none d-md-block"
                src="../../../../assets/app-assets/images/fotografias/smiley-business-people-with-pizza.png"
                alt="Image" />
              <figcaption>
                <div id="accordionWrap1" role="tablist" aria-multiselectable="true">
                  <div class="card collapse-icon accordion-icon-rotate">
                    <div id="heading14" class="card-header">
                      <a
                        data-toggle="collapse"
                        data-parent="#accordionWrap1"
                        href="#accordion14"
                        aria-expanded="false"
                        aria-controls="accordion14"
                        class="card-title lead collapsed title-acordion">
                        <i class="mr-1">
                          <img
                            src="../../../../assets/app-assets/images/icones-geia/seguro-corporativo.png"
                            width="40px" />
                        </i>
                        BENEFÍCIOS EMPRESARIAIS
                      </a>
                    </div>
                    <div
                      id="accordion14"
                      role="tabpanel"
                      aria-labelledby="heading14"
                      class="collapse"
                      aria-expanded="false">
                      <div class="card-content">
                        <div class="card-body title-a-geia">
                          Oferecemos planos de saúde e odontológico, além de seguro de vida para seus colaboradores.
                          <br />
                          <b class="geia-secundary">Mais que uma consultoria:</b>
                          administramos seus benefícios através de nossas especialidades.
                          <br />
                          ● Gestão Operacional
                          <br />
                          ● Gestão Financeira
                          <br />
                          ● Gestão de Saúde
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </figcaption>
            </figure>
          </div>
        </div>

        <div class="grid-hover row isMobile" style="margin-top: -4% !important">
          <div class="col-md-6 col-12 col-rem-pading">
            <figure class="effect-oscar">
              <figcaption>
                <div id="accordionWrap01">
                  <div data-appear="appear" class="card">
                    <div id="heading01" class="card-header-mobile">
                      <a class="flexMobileTitle title-acordion">
                        <i class="mr-1">
                          <img
                            src="../../../../assets/app-assets/images/icones-geia/seguro-corporativo.png"
                            width="40px" />
                        </i>
                        <p class="isMobileDescription">SEGUROS CORPORATIVOS</p>
                      </a>
                    </div>
                    <div class="card-backgroundColor-cinza">
                      <div class="card-content">
                        <div class="card-body title-a-geia">
                          <p class="text-justify mb-2 isMobileDescription">
                            <b class="geia-secundary">Prevenimos e asseguramos</b>
                            que o seu negócio esteja protegido caso haja sinistro, garantindo a reposição de acordo com
                            o que foi contratado. Esse é o nosso compromisso, oferecendo vasta gama de serviços, como:
                            Riscos Patrimoniais, Seguro Frota, Cyber Risks, Seguros Linhas Financeiras, Seguro de
                            Transporte Multi Modal, entre outros.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </figcaption>
            </figure>
          </div>
          <div class="col-md-6 col-12" style="padding-right: 0px; padding-left: 0px">
            <figure class="effect-oscar">
              <figcaption>
                <div>
                  <div class="card">
                    <div id="heading14" class="card-header-mobile">
                      <a class="flexMobileTitle title-acordion">
                        <i>
                          <img
                            src="../../../../assets/app-assets/images/icones-geia/seguro-corporativo.png"
                            width="40px" />
                        </i>
                        <p class="isMobileDescription">BENEFÍCIOS EMPRESARIAIS</p>
                      </a>
                    </div>
                    <div class="card-backgroundColor-cinza">
                      <div class="card-content">
                        <div class="card-body title-a-geia isMobileDescription">
                          Oferecemos planos de saúde e odontológico, além de seguro de vida para seus
                          <br />
                          colaboradores.
                          <br />
                          <b class="geia-secundary">Mais que uma consultoria:</b>
                          administramos seus benefícios através de nossas especialidades.
                          <ul>
                            <li>● Gestão Operacional</li>
                            <li>● Gestão Financeira</li>
                            <li>● Gestão de Saúde</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </figcaption>
            </figure>
          </div>
        </div>

        <!-- PME START -->
        <section class="gallery-section">
          <div class="container-fluid fluid-70">
            <div class="row gallery-loop justify-content-center">
              <!-- esconder no mobile d-sm-none d-md-block d-lg-block-->

              <div class="col-xl-4 d-none d-md-block col-md-4 d-lg-block col-lg-4 col-rem-pading">
                <div class="gallery-item-one mt-30">
                  <div class="gallery-thumbnail cursor-pointer">
                    <img
                      class="card-img-top img-fluid"
                      src="../../../../assets/app-assets/images/fotografias/para-familia.png"
                      alt="Para sua família e colaboradores" />
                  </div>
                  <div class="gallery-caption pme-hover">
                    <div>
                      <p class="title-banner upercase text-hove pme-hover-desc">Para sua família e colaboradores</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 d-none d-md-block col-md-4 d-lg-block col-lg-4 col-rem-pading">
                <div class="gallery-item-one mt-30">
                  <div class="gallery-thumbnail cursor-pointer">
                    <img
                      class="card-img-top img-fluid"
                      src="../../../../assets/app-assets/images/fotografias/PME.png"
                      alt="Microempreendedor Individual (MEI)" />
                  </div>
                  <div class="gallery-caption pme-hover">
                    <div>
                      <p class="title-banner upercase text-hove pme-hover-desc">Microempreendedor Individual (MEI)</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 d-none d-md-block col-md-4 d-lg-block col-lg-4 col-rem-pading">
                <div class="gallery-item-one mt-30">
                  <div class="gallery-thumbnail cursor-pointer">
                    <img
                      class="card-img-top img-fluid"
                      src="../../../../assets/app-assets/images/fotografias/MEI.png"
                      alt="PME" />
                  </div>
                  <div class="gallery-caption pme-hover">
                    <div>
                      <p class="title-banner upercase text-hove pme-hover-desc">PME</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- exibir no mobile d-sm-block d-md-none d-lg-none -->

            <div
              class="row align-items-center d-sm-block d-md-none d-lg-none col-md-4 d-lg-none justify-content-center">
              <div class="col-lg-12 col-md-12">
                <div class="faq-image text-center text-lg-left mb-md-50">
                  <div id="PME" class="carousel slide" data-ride="carousel">
                    <div class="grid-item" style="position: absolute; left: 418.422px; top: 925.375px"></div>
                    <div class="carousel-inner" role="listbox">
                      <div class="carousel-item">
                        <img src="../../../../assets/app-assets/images/fotografias/MEI.png" alt="First slide" />
                      </div>

                      <div class="carousel-item">
                        <img src="../../../../assets/app-assets/images/fotografias/PME.png" alt="Second slide" />
                      </div>
                      <div class="carousel-item active">
                        <img
                          src="../../../../assets/app-assets/images/fotografias/para-familia.png"
                          alt="Third slide" />
                      </div>
                    </div>
                    <a class="carousel-control-prev" href="#PME" role="button" data-slide="prev">
                      <button class="slick-arrow cursor-pointer prev-arrow prev arrow-slider">
                        <i class="fa fa-angle-left"></i>
                      </button>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#PME" role="button" data-slide="next">
                      <button class="slick-arrow cursor-pointer prev-arrow prev arrow-slider">
                        <i class="fa fa-angle-right"></i>
                      </button>
                      <span class="sr-only">Next</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="row align-items-center justify-content-center">
              <div class="col-lg-6 col-md-10 col-sm-12">
                <div class="text-center text-lg-left">
                  <div class="margin-card card-header" style="background-color: transparent">
                    <i class="mr-1">
                      <img src="../../../../assets/app-assets/images/icones-geia/Grupo-434.png" width="55px" />
                    </i>
                    <h4
                      style="margin-top: -60px; font-size: 16px; line-height: 1.3; font-weight: 600; padding-left: 13px"
                      class="ml-5">
                      PRODUTOS EXCLUSIVOS E DIFERENCIADOS PARA PME - MICROEMPREENDEDORES INDIVIDUAIS (MEI),PEQUENAS E
                      MÉDIAS EMPRESAS.
                    </h4>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-9 col-sm-11">
                <div class="faq-content pl-xl-5">
                  <p class="text-justify mb-2" style="line-height: 157%">
                    Com uma
                    <b>consultoria especializada</b>
                    , oferecemos as melhores soluções em saúde e seguros, para você e sua família ou para os seus
                    colaboradores. Os melhores convênios médicos e odontológicos, com ampla rede credenciada de
                    profissionais da saúde, clínicas e hospitais, além das melhores seguradoras para proteger o seu
                    negócio.
                    <b>Tudo em um só lugar.</b>
                  </p>

                  <br />
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- start-mobile -->
        <section class="mobile-gallery-section-produtos-exclusivos">
          <div class="carousel-mobile">
            <div id="PME-MOBILE" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner" role="listbox">
                <div class="carousel-item">
                  <img
                    src="../../../../assets/app-assets/images/fotografias/casal-carousel-img.png"
                    alt="First slide"
                    class="mobile-carousel-item" />
                </div>

                <div class="carousel-item">
                  <img
                    src="../../../../assets/app-assets/images/fotografias/homem-branco-cabelo-castanho-carousel.png"
                    alt="Second slide"
                    class="mobile-carousel-item" />
                </div>
                <div class="carousel-item active">
                  <img
                    src="../../../../assets/app-assets/images/fotografias/mulher-negra-cabelo-ruivo-carousel.png"
                    alt="Third slide"
                    class="mobile-carousel-item" />
                </div>

                <div class="carousel-item">
                  <img
                    src="../../../../assets/app-assets/images/fotografias/mulher-negra-cabelo-liso-carousel.png"
                    alt="Fourth slide"
                    class="mobile-carousel-item" />
                </div>
              </div>
            </div>
          </div>

          <div class="mobile-gallery-section-produtos-exclusivos-content">
            <div class="margin-card">
              <a class="card-title lead title-acordion">
                <i>
                  <img src="../../../../assets/app-assets/images/icones-geia/Grupo-434.png" width="55px" />
                </i>
                <h4
                  class="mt-2"
                  style="
                    font-size: clamp(10px, 4vw, 16px);
                    line-height: 1.3;
                    font-weight: 600;
                    word-break: break-all;
                    text-align: justify;
                    hyphens: auto;
                    -webkit-hyphens: auto;
                    word-spacing: -0.05em;
                    white-space: pre-line;
                  ">
                  PRODUTOS EXCLUSIVOS E DIFERENCIADOS PARA PME - MICROEMPREENDEDORES INDIVIDUAIS (MEI), PEQUENAS E
                  MÉDIAS EMPRESAS.
                </h4>
              </a>
            </div>
            <div>
              <div
                class="faq-content pl-xl-5"
                style="text-align: justify; hyphens: auto; -webkit-hyphens: auto; word-spacing: -0.05em">
                <p
                  style="
                    line-height: 1.2;
                    text-align: justify;
                    font-size: clamp(10px, 4.5vw, 16px);
                    word-spacing: -0.09em;
                    word-break: break-all;
                    hyphens: auto;
                  ">
                  Com uma
                  <b>consultoria especializada</b>
                  , oferecemos as melhores soluções em saúde e seguros, para você e sua família ou para os os seus
                  colaboradores. Os melhores convênios médicos e odontológicos com ampla rede credenciada de
                  profissionais da saúde, clínicas e hospitais, além das melhores seguradoras para proteger o seu
                  negócio.
                  <b>Tudo em um só lugar.</b>
                </p>

                <br />
              </div>
              <a class="carousel-control-prev" href="#PME-MOBILE" role="button" data-slide="prev">
                <span class="" aria-hidden="true"></span>
                <!-- <span class="sr-only">Previous</span> -->
              </a>
              <a
                style="margin-right: clamp(26vh, 26vh, 26vh)"
                class="carousel-control-next"
                href="#PME-MOBILE"
                role="button"
                data-slide="next">
                <span class="" aria-hidden="true"></span>
                <!-- <span class="sr-only">Next</span> -->
              </a>
            </div>
          </div>
          <!-- end mobile -->
        </section>
        <!-- PME END -->
      </div>
    </section>
    <!-- A Geia - EMPRESAS END -->
    <!-- PARA PEQUENAS E MEDIAS EMPRESAS START -->

    <section
      id="fale-com-consultor"
      class="container-fluid"
      style="padding-top: 0px !important; background-color: #023342 !important; text-align: -webkit-center !important">
      <div class="row container">
        <div class="col-sm-12 col-md-6 container-fluid">
          <!-- Coluna direita com o texto -->
          <div class="section-heading heading-white mb-2">
            <h2 class="title-left coletivo-adesao-h2 text-bold-600 text-white mt-2" style="font-weight: 600 !important">
              PARA PEQUENAS, MÉDIAS
            </h2>
            <h2 class="title-left coletivo-adesao-h2 text-bold-600 text-white" style="font-weight: 700">
              E GRANDES EMPRESAS
            </h2>
            <p
              class="mt-1 text-white mb-1"
              style="font-weight: 200; font-weight: 200; text-align: justify; hyphens: auto">
              Produtos e serviços personalizados de acordo com a necessidade da empresa: planos de saúde, planos
              odontológicos e seguros, além de uma equipe cuidando da gestão de saúde, gerenciamento de risco,
              inadimplência, cobrança e faturamento.
            </p>

            <div class="row col-auto col-lg-12 col-sm-12 mt-2" style="margin-left: -3rem !important">
              <a href="https://api.whatsapp.com/send?phone=551136602000&text=oi" target="_blank">
                <button type="button" class="btn-min-width box-shadow-5 btn mr-1 btn-lg" style="background: #f2f5f5">
                  <b>
                    <i class="fa fa-commenting-o" aria-hidden="true"></i>
                    FALE COM NOSSOS CONSULTORES
                  </b>
                </button>
              </a>
            </div>
          </div>
        </div>
        <div
          class="container-fluid col-sm-6 col-md-5 d-none d-sm-none d-md-block d-lg-block"
          style="
            background-image: url(../../../../assets/app-assets/images/fotografias/banner-p-m-empresas.png);
            background-position: center !important;
            background-repeat: no-repeat !important;
            background-size: 109% !important;
          "></div>
      </div>
    </section>

    <!-- PARA PEQUENAS E MEDIAS EMPRESAS END -->
    <!--======  COLETIVO POR ADESAO ======-->
    <section class="about-section section-gap bg-geia-azul border-top-primary">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <!-- COLETIVO POR ADESAO -->
          <div class="section-heading mb-20">
            <div style="margin-top: -113px !important">
              <h2 class="title-banner not-uper-case font-weight-bold">Parcerias com Sindicatos</h2>
              <h2 class="title sub-title-banner associacoes-h2 text-white">e Associações Profissionais</h2>
            </div>
          </div>
          <!-- COLETIVO POR ADESAO END -->

          <div class="col-lg-7 col-md-10">
            <div
              class="card"
              style="
                border-bottom-left-radius: 20px;
                border-bottom-right-radius: 20px;
                box-shadow: 1px 1px 1px 0px grey;
              ">
              <div class="card-content">
                <div class="embed-responsive embed-responsive-item embed-responsive-16by9">
                  <iframe
                    class="img-thumbnail"
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/EGqxruh5-NM?rel=0&amp;controls=0&amp;showinfo=0"
                    title="Geia ON"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                      web-share;
                    "
                    allowfullscreen></iframe>
                </div>
                <div class="card-body float-right">
                  <a href="https://www.youtube.com/@GeiaConsultoria" target="_blank" class="bold-azul bold-azul-geia">
                    <i class="bold-azul bold-azul-geia">
                      <b>MAIS CONTEÚDO</b>
                    </i>
                    <i class="ml-1 fa fa-arrow-right bold-azul-geia"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-8" style="margin-bottom: 41px">
            <div class="about-content">
              <div class="section-heading">
                <h2 class="tagline">
                  <span class="span-badge-geia badge badge-dark">Planos</span>
                </h2>
                <h2 class="title-left coletivo-adesao-h2 text-bold-600 title-color-azul">COLETIVO POR ADESÃO</h2>
              </div>

              <p class="mt-2 text-white">
                A Géia possui
                <b>relacionamento</b>
                com os mais diversos sindicatos e associações de classe garantindo planos de saúde e odonto com
                <b class="bold-azul-geia text-white">qualidade por um preço mais acessível.</b>
              </p>
              <p class="text-white">
                <b>Para contratar esse tipo de plano, é necessário que você esteja</b>
                <b class="bold-azul-geia text-white">vinculado à uma associação profissional ou à um sindicato.</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--COLETIVO POR ADESAO END -->

    <!-- TABS PARCEIROS E ENTIDADES -->
    <section id="vertical-tabs" class="about-section bg-geia-azul mt-entidades-on-mobile">
      <div class="container">
        <!-- VERTICAL ABAS -->
        <div class="row match-height">
          <div class="col-xl-12 col-lg-12">
            <div class="card" style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; border-radius: 30px">
              <div class="card-content">
                <div class="card-body" style="padding: 0px">
                  <div class="row">
                    <div class="col-12 mt-3 mb-1">
                      <h2 class="title text-center entidade-h2">CONHEÇA NOSSAS ENTIDADES PARCEIRAS!</h2>
                      <h2 class="area-atuacao-sub-title title text-center">Áreas de atuação:</h2>
                    </div>
                  </div>
                  <div class="nav-vertical">
                    <ul class="nav nav-tabs nav-left nav-border-left" style="height: 123.883px">
                      <li class="nav-item">
                        <a
                          class="nav-link active show"
                          id="tecnologia"
                          data-toggle="tab"
                          aria-controls="tabVerticalTech"
                          href="#tabVerticalTech"
                          aria-expanded="true">
                          Tecnologia
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="abaEducacao"
                          data-toggle="tab"
                          aria-controls="tabEducacao"
                          href="#tabEducacao"
                          aria-expanded="false">
                          Educação
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="baseSaude"
                          data-toggle="tab"
                          aria-controls="tabSaude"
                          href="#tabSaude"
                          aria-expanded="false">
                          Saúde
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="baseJuridica"
                          data-toggle="tab"
                          aria-controls="tabJuridica"
                          href="#tabJuridica"
                          aria-expanded="false">
                          Jurídica
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="baseCivil"
                          data-toggle="tab"
                          aria-controls="tabCivil"
                          href="#tabCivil"
                          aria-expanded="false">
                          Construção Civil
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="baseSeguranca"
                          data-toggle="tab"
                          aria-controls="tabSeguranca"
                          href="#tabSeguranca"
                          aria-expanded="false">
                          Segurança
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="baseEstudante"
                          data-toggle="tab"
                          aria-controls="tabEstudante"
                          href="#tabEstudante"
                          aria-expanded="false">
                          Sou Estudante
                        </a>
                      </li>
                    </ul>

                    <div class="tab-content px-1">
                      <!-- ABA TECNOLOGIA  -->
                      <div
                        role="tabpanel "
                        class="tab-pane not-overflow active"
                        id="tabVerticalTech"
                        aria-expanded="true"
                        aria-labelledby="tecnologia">
                        <div class="container-fluid fluid-100">
                          <div class="row justify-content-center custom-service-grid">
                            <!-- SLIDER TECNOLOGIA START  -->
                            <div class="container">
                              <div class="row">
                                <div id="carousel-tecnologia" class="carousel slide mt-60" data-ride="carousel">
                                  <div class="carousel-inner">
                                    <!-- slider 01 start -->
                                    <div class="container">
                                      <div class="row">
                                        <div class="carousel-inner">
                                          <div class="carousel-item active">
                                            <div class="slide-box" style="margin-top: 85px">
                                              <img
                                                src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                alt="ASSOCIAÇÃO OS SERVIDORES PUBLICOS DE SP" />
                                            </div>
                                          </div>
                                          <div class="carousel-item">
                                            <div class="slide-box mt-1" style="margin-top: 85px !important">
                                              <img
                                                src="../../../../assets/app-assets/images/Sindicatos/Abraweb.png"
                                                alt="ASSOCIAÇÃO BRASILEIRA DE PROFISSIONAIS DA INTERNET" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="icon-w-mobile-tech">
                                        <a
                                          class="carousel-control-prev"
                                          href="#carousel-tecnologia"
                                          role="button"
                                          data-slide="prev">
                                          <span
                                            class="carousel-control-prev-icon icon-arow-style"
                                            aria-hidden="true"></span>
                                          <span class="sr-only">Previous</span>
                                        </a>
                                        <a
                                          class="carousel-control-next"
                                          href="#carousel-tecnologia"
                                          role="button"
                                          data-slide="next">
                                          <span
                                            class="carousel-control-next-icon icon-arow-style"
                                            aria-hidden="true"></span>
                                          <span class="sr-only">Next</span>
                                        </a>
                                      </div>
                                    </div>
                                    <!-- slider 02 end -->
                                  </div>
                                </div>
                                <!-- <div class="d-none d-sm-block d-md-none">
                              <a style="margin-top: 130px;
                              justify-content: center;
                              margin-left: 14rem;" class="carousel-control-prev" href="#carousel-tecnologia"
                                  role="button" data-slide="prev">
                                  <span class="carousel-control-prev-icon icon-arow-style" aria-hidden="true"></span>
                                  <span class="sr-only">Previous</span>
                                </a>
                            </div> -->
                              </div>
                            </div>
                            <!-- SLIDER TECNOLOGIA  END -->
                          </div>
                        </div>
                      </div>

                      <div class="tab-pane show not-overflow" id="tabEducacao" aria-labelledby="abaEducacao">
                        <div class="container-fluid fluid-100">
                          <div class="row justify-content-center custom-service-grid">
                            <!-- SLIDER EDUCAO START  -->
                            <div class="container">
                              <div class="row">
                                <!-- data-ride="carousel"  -->
                                <div
                                  id="carousel-educacao"
                                  class="carousel slide"
                                  data-ride="carousel"
                                  data-interval="false">
                                  <div class="carousel-inner">
                                    <div class="carousel-item active">
                                      <div class="row">
                                        <div class="d-none d-lg-block">
                                          <div class="slide-box">
                                            <div class="row justify-content-center custom-service-grid">
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 40em; margin-left: -50px">
                                                    <img
                                                      src="../../../../assets/app-assets/images/Sindicatos/CPP logo.png"
                                                      alt="CENTRO DO PROFESSORADO PAULISTA" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 40em">
                                                    <img
                                                      width="150% !important"
                                                      src="../../../../assets/app-assets/images/Sindicatos/UDEMO 2011.png"
                                                      alt="SINDICATO ESPECIALISTA DE EDUCAÇÃO DO MAGISTÉRIO OFICIAL DO ESTADO DE SÃO PAULO
                                  " />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="d-none d-md-block d-lg-none">
                                          <div class="slide-box">
                                            <div
                                              class="row justify-content-center custom-service-grid"
                                              style="display: inline-grid; justify-items: center">
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 32em">
                                                    <img
                                                      src="../../../../assets/app-assets/images/Sindicatos/CPP logo.png"
                                                      alt="CENTRO DO PROFESSORADO PAULISTA" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 33em">
                                                    <img
                                                      width="150% !important"
                                                      src="../../../../assets/app-assets/images/Sindicatos/UDEMO 2011.png"
                                                      alt="SINDICATO ESPECIALISTA DE EDUCAÇÃO DO MAGISTÉRIO OFICIAL DO ESTADO DE SÃO PAULO
                                  " />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="d-none d-sm-block d-md-none">
                                          <div class="slide-box">
                                            <div class="row justify-content-center custom-service-grid">
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail">
                                                    <img
                                                      src="../../../../assets/app-assets/images/Sindicatos/CPP logo.png"
                                                      alt="CENTRO DO PROFESSORADO PAULISTA" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail">
                                                    <img
                                                      width="150% !important"
                                                      src="../../../../assets/app-assets/images/Sindicatos/UDEMO 2011.png"
                                                      alt="SINDICATO ESPECIALISTA DE EDUCAÇÃO DO MAGISTÉRIO OFICIAL DO ESTADO DE SÃO PAULO
                                  " />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="d-block d-sm-none">
                                          <div
                                            class="row justify-content-center custom-service-grid"
                                            style="display: grid; justify-items: center">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/CPP logo.png"
                                                    alt="CENTRO DO PROFESSORADO PAULISTA"
                                                    class="d-block w-100" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/UDEMO 2011.png"
                                                    alt="SINDICATO ESPECIALISTA DE EDUCAÇÃO DO MAGISTÉRIO OFICIAL DO ESTADO DE SÃO PAULO
                                "
                                                    class="d-block w-100" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="carousel-item">
                                      <div class="row">
                                        <div class="d-none d-lg-block mt-60" style="margin-top: 46px !important">
                                          <div class="slide-box">
                                            <div class="row justify-content-center custom-service-grid">
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 40em; margin-left: -50px">
                                                    <img
                                                      width="150% !important"
                                                      src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                      alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                               " />
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 40em">
                                                    <img
                                                      src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                      alt="SINDICATO DOS SUPERVISORES DE
                                                                         ENSINO DO
                                                                         MAGISTÉRIO OFICIAL NO ESTADO DE
                                                                         SÃO PAULO" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="d-none d-md-block d-lg-none">
                                          <div class="slide-box">
                                            <div
                                              class="row justify-content-center custom-service-grid"
                                              style="display: inline-grid; justify-items: center">
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 32em">
                                                    <img
                                                      width="150% !important"
                                                      src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                      alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                             " />
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 33em">
                                                    <img
                                                      src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                      alt="SINDICATO DOS SUPERVISORES DE
                                                                         ENSINO DO
                                                                         MAGISTÉRIO OFICIAL NO ESTADO DE
                                                                         SÃO PAULO" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="d-none d-sm-block d-md-none">
                                          <div class="slide-box">
                                            <div class="row justify-content-center custom-service-grid">
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail">
                                                    <img
                                                      width="150% !important"
                                                      src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                      alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                             " />
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail">
                                                    <img
                                                      src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                      alt="SINDICATO DOS SUPERVISORES DE
                                                                         ENSINO DO
                                                                         MAGISTÉRIO OFICIAL NO ESTADO DE
                                                                         SÃO PAULO" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="d-block d-sm-none mt-60">
                                          <div
                                            class="row justify-content-center custom-service-grid"
                                            style="display: grid; justify-items: center">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                  <img
                                                    width="150% !important"
                                                    src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                    alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                           " />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                    alt="SINDICATO DOS SUPERVISORES DE
                                                                       ENSINO DO
                                                                       MAGISTÉRIO OFICIAL NO ESTADO DE
                                                                       SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- <div class="carousel-item">
                                    <div class="row">
                                      <div class="d-none d-lg-block">
                                        <div class="slide-box">
                                          <div class="row justify-content-center custom-service-grid mt-3">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 40em; margin-left: -50px;">
                                                  <img width="150% !important"
                                                    src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                    alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                               ">

                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="mt-30">
                                                  <div class="box-thumbnail" style="width: 40em;">
                                                    <img src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                      alt="SINDICATO DOS SUPERVISORES DE
                                                                             ENSINO DO
                                                                             MAGISTÉRIO OFICIAL NO ESTADO DE
                                                                             SÃO PAULO"/>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-none d-md-block d-lg-none">
                                        <div class="slide-box">
                                          <div class="row justify-content-center custom-service-grid" style="
                                display: inline-grid;
                                justify-items: center;
                            ">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="margin: auto;width: 40em;">
                                                  <img width="150% !important"
                                                    src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                    alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                     ">
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 40em;">


                                                  <img src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                    alt="SINDICATO DOS SUPERVISORES DE
                                                                             ENSINO DO
                                                                             MAGISTÉRIO OFICIAL NO ESTADO DE
                                                                             SÃO PAULO">
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-none d-sm-block d-md-none">
                                        <div class="slide-box">
                                          <div class="row justify-content-center custom-service-grid"
                                            style="display: grid; justify-items: center;">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail">
                                                  <img width="150% !important"
                                                    src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                    alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                              ">
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail">
                                                  <img src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                    alt="SINDICATO DOS SUPERVISORES DE
                          ENSINO DO
                          MAGISTÉRIO OFICIAL NO ESTADO DE
                          SÃO PAULO">
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-block d-sm-none mt-3">
                                        <div class="row justify-content-center custom-service-grid"
                                          style="display: grid; justify-items: center;">
                                          <div class="col">
                                            <div class="mt-30">
                                              <div class="box-thumbnail" style="width: 70%; margin: auto;">
                                                <img
                                                  src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                  alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP
                                                                              " class="d-block w-100">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col">
                                            <div class="mt-30">
                                              <div class="box-thumbnail" style="width: 70%; margin: auto;">
                                                <img src="../../../../assets/app-assets/images/Sindicatos/Apase.jpg"
                                                  alt="SINDICATO DOS SUPERVISORES DE
                                                                          ENSINO DO
                                                                          MAGISTÉRIO OFICIAL NO ESTADO DE
                                                                          SÃO PAULO" class="d-block w-100">
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->
                                  </div>

                                  <div class="icon-w-mobile-tech">
                                    <a
                                      class="carousel-control-prev"
                                      href="#carousel-educacao"
                                      role="button"
                                      data-slide="prev">
                                      <span
                                        class="carousel-control-prev-icon icon-arow-style"
                                        aria-hidden="true"></span>
                                      <span class="sr-only">Previous</span>
                                    </a>
                                    <a
                                      class="carousel-control-next"
                                      href="#carousel-educacao"
                                      role="button"
                                      data-slide="next">
                                      <span
                                        class="carousel-control-next-icon icon-arow-style"
                                        aria-hidden="true"></span>
                                      <span class="sr-only">Next</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- SLIDER EDUCAO  END -->
                          </div>
                        </div>
                      </div>
                      <!-- ABA EDUCACAO END -->
                      <!-- ABA SAUDE  -->
                      <div class="tab-pane not-overflow" id="tabSaude" aria-labelledby="baseSaude">
                        <div class="row justify-content-center custom-service-grid">
                          <!-- SLIDER saude START  -->
                          <div class="container">
                            <div class="row">
                              <div id="carousel-saude" data-interval="false" class="carousel slide">
                                <div class="carousel-inner">
                                  <div class="carousel-item active">
                                    <div class="row">
                                      <div class="d-none d-lg-block">
                                        <div class="slide-box">
                                          <div class="row justify-content-center custom-service-grid mt-5">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 40em; margin-left: -50px">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                    alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 40em">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/ASSPTJSP.png"
                                                    alt="ASSOCIAÇÃO DOS ASSISTENTES SOCIAIS E PSICÓLOGOS DO TRIBUNAL DE  JUSTIÇA DO ESTADO DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-none d-md-block d-lg-none">
                                        <div class="slide-box">
                                          <div
                                            class="row justify-content-center custom-service-grid"
                                            style="display: inline-grid; justify-items: center">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 30em">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                    alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 30em">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/ASSPTJSP.png"
                                                    alt="ASSOCIAÇÃO DOS ASSISTENTES SOCIAIS E PSICÓLOGOS DO TRIBUNAL DE  JUSTIÇA DO ESTADO DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-none d-sm-block d-md-none">
                                        <div class="slide-box">
                                          <div
                                            class="row justify-content-center custom-service-grid"
                                            style="display: grid; justify-items: center">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                    alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/ASSPTJSP.png"
                                                    alt="ASSOCIAÇÃO DOS ASSISTENTES SOCIAIS E PSICÓLOGOS DO TRIBUNAL DE  JUSTIÇA DO ESTADO DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-block d-sm-none mt-2">
                                        <div
                                          class="row justify-content-center custom-service-grid"
                                          style="display: grid; justify-items: center">
                                          <div class="col">
                                            <div class="mt-30">
                                              <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                <img
                                                  src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                                  alt="ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP"
                                                  class="d-block w-100" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col">
                                            <div class="mt-30">
                                              <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                <img
                                                  src="../../../../assets/app-assets/images/Sindicatos/ASSPTJSP.png"
                                                  alt="ASSOCIAÇÃO DOS ASSISTENTES SOCIAIS E PSICÓLOGOS DO TRIBUNAL DE  JUSTIÇA DO ESTADO DE SÃO PAULO"
                                                  class="d-block w-100" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="carousel-item">
                                    <div class="row">
                                      <div class="d-none d-lg-block">
                                        <div class="slide-box">
                                          <div class="row justify-content-center custom-service-grid">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 40em; margin-left: -50px">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/Logo SindiNutri-SP Fundo Branco.png"
                                                    alt=" SINDICATO DOS NUTRICIONISTAS  DO ESTADO DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 40em">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/Marca CRO-SP CMYK.png"
                                                    alt="CONSELHO REGIONAL DE ODONTOLOGIA DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-none d-md-block d-lg-none">
                                        <div class="slide-box">
                                          <div
                                            class="row justify-content-center custom-service-grid"
                                            style="display: inline-grid; justify-items: center">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 30em; margin-left: 5em">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/Marca CRO-SP CMYK.png"
                                                    alt="CONSELHO REGIONAL DE ODONTOLOGIA DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail" style="width: 33em">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/Logo SindiNutri-SP Fundo Branco.png"
                                                    alt=" SINDICATO DOS NUTRICIONISTAS  DO ESTADO DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-none d-sm-block d-md-none">
                                        <div class="slide-box">
                                          <div
                                            class="row justify-content-center custom-service-grid"
                                            style="display: grid; justify-items: center">
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/Marca CRO-SP CMYK.png"
                                                    alt="CONSELHO REGIONAL DE ODONTOLOGIA DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <div class="mt-30">
                                                <div class="box-thumbnail">
                                                  <img
                                                    src="../../../../assets/app-assets/images/Sindicatos/Logo SindiNutri-SP Fundo Branco.png"
                                                    alt=" SINDICATO DOS NUTRICIONISTAS  DO ESTADO DE SÃO PAULO" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-block d-sm-none">
                                        <div
                                          class="row justify-content-center custom-service-grid"
                                          style="display: grid; justify-items: center">
                                          <div class="col">
                                            <div class="mt-30">
                                              <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                <img
                                                  src="../../../../assets/app-assets/images/Sindicatos/Marca CRO-SP CMYK.png"
                                                  alt="CONSELHO REGIONAL DE ODONTOLOGIA DE SÃO PAULO"
                                                  class="d-block w-100" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col">
                                            <div class="mt-30">
                                              <div class="box-thumbnail" style="width: 70%; margin: auto">
                                                <img
                                                  src="../../../../assets/app-assets/images/Sindicatos/Logo SindiNutri-SP Fundo Branco.png"
                                                  alt=" SINDICATO DOS NUTRICIONISTAS  DO ESTADO DE SÃO PAULO"
                                                  class="d-block w-100" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="a">
                                  <a
                                    class="carousel-control-prev"
                                    href="#carousel-saude"
                                    role="button"
                                    data-slide="prev">
                                    <span
                                      class="carousel-control-prev-icon icon-left-civil-moible icon-arow-style"
                                      aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                  </a>
                                  <a
                                    class="carousel-control-next"
                                    href="#carousel-saude"
                                    role="button"
                                    data-slide="next">
                                    <span
                                      class="carousel-control-next-icon icon-rigth-civil-moible icon-arow-style"
                                      aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                  </a>
                                </div>

                                <!-- <div class="row-arow-directions"><a href="#carousel-saude" role="button" data-slide="prev"
                                  class="carousel-control-prev mt-mobile-icon-arro-left-saude-mobile"><button
                                    class="slick-arrow cursor-pointer prev-arrow prev arrow-slider"><i
                                      class="fa fa-angle-left bold"></i></button><span
                                    class="sr-only">Previous</span></a>
                                <a href="#carousel-saude" role="button" data-slide="next"
                                  class="carousel-control-next mt-mobile-icon-arro-rigth-saude-mobile">

                                  <button class="slick-arrow cursor-pointer prev-arrow prev arrow-slider">
                                    <i class="fa fa-angle-right bold"></i></button><span class="sr-only">Next</span></a>
                              </div> -->
                              </div>
                            </div>
                          </div>
                          <!-- SLIDER SAUDE  END -->
                        </div>
                      </div>
                      <!-- ABA SAUDE END -->
                      <!-- ABA JURIDICA  -->
                      <div class="tab-pane not-overflow" id="tabJuridica" aria-labelledby="baseJuridica">
                        <div class="container-fluid fluid-100">
                          <div class="row justify-content-center custom-service-grid">
                            <div class="container">
                              <div class="row">
                                <div id="carousel-juridica" class="carousel slide" data-ride="carousel">
                                  <div class="carousel-inner">
                                    <!-- slider 01 start -->
                                    <div class="carousel-item active">
                                      <div class="row mt-35">
                                        <div class="d-none d-lg-block">
                                          <div
                                            class="slide-box icons-center-slider"
                                            style="width: 83%; margin-left: 77px">
                                            <img
                                              src="../../../../assets/app-assets/images/Sindicatos/ABJE.png"
                                              alt=" ASSOCIAÇÃO BENEFICENTE  DA
                                              JUSTIÇA ELEITORAL" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="d-none d-md-block d-lg-none">
                                        <div class="slide-box icons-center-slider">
                                          <img
                                            width="150% !important"
                                            src="../../../../assets/app-assets/images/Sindicatos/ABJE.png"
                                            alt="ASSOCIAÇÃO BENEFICENTE  DA
                                            JUSTIÇA ELEITORAL" />
                                        </div>
                                      </div>

                                      <div class="d-none d-sm-block d-md-none">
                                        <div class="slide-box icons-center-slider">
                                          <img
                                            src="../../../../assets/app-assets/images/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                            alt=" ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP" />
                                        </div>
                                      </div>
                                      <!-- Vsivel somente em mobile -->
                                      <div class="d-block d-sm-none mt-35">
                                        <img
                                          class="d-block"
                                          src="../../../../assets/app-assets/images/Sindicatos/ABJE.png"
                                          alt=" ASSOCIAÇÃO BENEFICENTE  DA JUSTIÇA ELEITORAL" />
                                      </div>
                                    </div>
                                    <!-- slider 01 end -->

                                    <!-- slider 02 start -->

                                    <div class="carousel-item">
                                      <div class="d-none d-lg-block mt-120">
                                        <div class="slide-box icons-center-slider">
                                          <img
                                            src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                            alt="ASSOCIAÇÃO DOS
                                            SERVIDORES PÚBLICOS - SP" />
                                        </div>
                                      </div>
                                      <!-- visivel em dispositivos maior que mobile d-md-block -->
                                      <div class="d-none d-md-block d-lg-none">
                                        <div class="slide-box icons-center-slider mt-120">
                                          <img
                                            src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                            alt="ASSOCIAÇÃO DOS
                                            SERVIDORES PÚBLICOS - SP" />
                                        </div>
                                      </div>
                                      <!-- Visível eapenas em mobile	as telas .d-sm-block -->
                                      <div class="d-none d-sm-block d-md-none" style="margin-top: 120px !important">
                                        <div class="slide-box icons-center-slider">
                                          <img
                                            src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                            alt="ASSOCIAÇÃO DOS SERVIDORES
                                            PÚBLICOS - SP" />
                                        </div>
                                      </div>
                                      <!-- Visível em todas	as telas .d-block -->
                                      <div class="d-block d-sm-none" style="margin-top: 120px !important">
                                        <img
                                          class="d-block"
                                          src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                          alt=" ASSOCIAÇÃO DOS SERVIDORES
                                          PÚBLICOS - SP" />
                                      </div>
                                    </div>
                                    <!-- slider 02 end -->
                                  </div>

                                  <!-- <div class="row-arow-directions">
                                  <a class="carousel-control-prev" href="#carousel-juridica" role="button"
                                    data-slide="prev">
                                    <button class="slick-arrow cursor-pointer prev-arrow prev arrow-slider">
                                      <i class="fa fa-angle-left"></i>
                                    </button>
                                    <span class="sr-only">Previous</span>
                                  </a>
                                  <a class="carousel-control-next" href="#carousel-juridica" role="button"
                                    data-slide="next">
                                    <button class="slick-arrow cursor-pointer prev-arrow prev arrow-slider">
                                      <i class="fa fa-angle-right"></i>
                                    </button>
                                    <span class="sr-only">Next</span>
                                  </a>
                                </div> -->
                                  <div class="row-arow-directions">
                                    <a
                                      class="carousel-control-prev"
                                      href="#carousel-juridica"
                                      role="button"
                                      data-slide="prev">
                                      <span
                                        class="carousel-control-prev-icon icon-left-civil-moible icon-arow-style"
                                        aria-hidden="true"></span>
                                      <span class="sr-only">Previous</span>
                                    </a>
                                    <a
                                      class="carousel-control-next"
                                      href="#carousel-juridica"
                                      role="button"
                                      data-slide="next">
                                      <span
                                        class="carousel-control-next-icon icon-rigth-civil-moible icon-arow-style"
                                        aria-hidden="true"></span>
                                      <span class="sr-only">Next</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ABA JURIDICA END -->
                      <!-- ABA CONSTRUCAO  START -->

                      <div class="tab-pane not-overflow" id="tabCivil" aria-labelledby="baseCivil">
                        <div class="row justify-content-center custom-service-grid">
                          <div class="container">
                            <div class="row">
                              <div id="carousel-civil" data-ride="carousel" class="carousel slide">
                                <div class="carousel-inner mt-1">
                                  <div class="carousel-item active">
                                    <div class="slide-box mt-1 mt-civil-mobile">
                                      <img
                                        src="../../../../assets/app-assets/images/Sindicatos/SASP2.png"
                                        alt="SINDICATO DOS ARQUITETOS NO ESTADO DE SAO PAULO"
                                        style="margin-top: -30px" />
                                    </div>
                                  </div>
                                  <div class="carousel-item">
                                    <div class="slide-box mt-4">
                                      <img
                                        src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                        alt="ASSOCIAÇÃO DOS  SERVIDORES PÚBLICOS - SP"
                                        style="width: 96px" />
                                    </div>
                                  </div>
                                </div>
                                <div class="icon-w-mobile-civil">
                                  <a
                                    class="carousel-control-prev"
                                    href="#carousel-civil"
                                    role="button"
                                    data-slide="prev">
                                    <span
                                      class="carousel-control-prev-icon icon-left-civil-moible icon-arow-style"
                                      aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                  </a>
                                  <a
                                    class="carousel-control-next"
                                    href="#carousel-civil"
                                    role="button"
                                    data-slide="next">
                                    <span
                                      class="carousel-control-next-icon icon-rigth-civil-moible icon-arow-style"
                                      aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ABA CONSTRUCAO  -->
                      <!-- ABA SEGURANCA -->
                      <div class="tab-pane not-overflow" id="tabSeguranca" aria-labelledby="baseSeguranca">
                        <div class="row justify-content-center custom-service-grid">
                          <div class="container">
                            <div class="row">
                              <div id="carousel-seguranca" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner mt-1">
                                  <div class="carousel-item active">
                                    <div
                                      class="slide-box mt-1 mt-mobile-seguranca-left"
                                      style="width: 70%; margin: auto">
                                      <img
                                        src="../../../../assets/app-assets/images/Sindicatos/UPS logosf.png"
                                        alt=" UNIÃO DOS PROFISSIONAIS DE SEGURANÇA" />
                                    </div>
                                  </div>
                                  <div class="carousel-item">
                                    <div class="slide-box mt-4 mt-mobile-seguranca-rigth">
                                      <img
                                        src="../../../../assets/app-assets/images/Sindicatos/LOGOTIPO ADSERVIP - SP OFICIAL.jpg"
                                        alt=" ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS - SP" />
                                    </div>
                                  </div>
                                </div>
                                <div class="icon-w-mobile-civil">
                                  <a
                                    class="carousel-control-prev"
                                    href="#carousel-seguranca"
                                    role="button"
                                    data-slide="prev">
                                    <span
                                      class="carousel-control-prev-icon icon-left-civil-moible icon-arow-style"
                                      aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                  </a>
                                  <a
                                    class="carousel-control-next"
                                    href="#carousel-seguranca"
                                    role="button"
                                    data-slide="next">
                                    <span
                                      class="carousel-control-next-icon icon-rigth-civil-moible icon-arow-style"
                                      aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- ABA SEGURANCA END-->
                      <!-- ABA ESTUDANTES -->

                      <div class="tab-pane not-overflow" id="tabEstudante" aria-labelledby="baseEstudante">
                        <div class="row justify-content-center custom-service-grid">
                          <div class="container">
                            <div class="row">
                              <div id="carousel-estudante" data-interval="false" class="carousel slide">
                                <div class="carousel-inner">
                                  <div class="carousel-item active">
                                    <div class="row mt-60">
                                      <div class="d-none d-lg-block mt-2">
                                        <div
                                          class="slide-box icons-center-slider"
                                          style="width: 184% !important; margin-left: 40px">
                                          <img
                                            src="../../../../assets/app-assets/images/Sindicatos/logo-ube.png"
                                            alt=" UNIÃO BRASILEIRA DOS ESTUDANTES" />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-none d-md-block d-lg-none">
                                      <div
                                        class="slide-box icons-center-slider mt-120"
                                        style="width: 142%; margin-left: -89px">
                                        <img
                                          src="../../../../assets/app-assets/images/Sindicatos/logo-ube.png"
                                          alt=" UNIÃO BRASILEIRA DOS ESTUDANTES" />
                                      </div>
                                    </div>
                                    <div class="d-none d-sm-block d-md-none mt-120">
                                      <div
                                        class="slide-box icons-center-slider"
                                        style="width: 132%; margin-left: -89px">
                                        <img
                                          src="../../../../assets/app-assets/images/Sindicatos/logo-ube.png"
                                          alt=" UNIÃO BRASILEIRA DOS ESTUDANTES" />
                                      </div>
                                    </div>
                                    <div
                                      class="d-block d-sm-none mt-100"
                                      style="margin-top: 97px !important; width: 180px; margin: auto">
                                      <img
                                        src="../../../../assets/app-assets/images/Sindicatos/logo-ube.png"
                                        alt=" UNIÃO BRASILEIRA DOS ESTUDANTES"
                                        class="d-block" />
                                    </div>
                                  </div>
                                  <div class="carousel-item">
                                    <div class="d-none d-lg-block mt-30">
                                      <div
                                        class="slide-box icons-center-slider"
                                        style="width: 114% !important; margin-left: -8em; margin: auto">
                                        <img
                                          src="../../../../assets/app-assets/images/Sindicatos/tecnologo.png"
                                          alt="SINDICATOS DOS TECNOLOGOS" />
                                      </div>
                                    </div>
                                    <div class="d-none d-md-block d-lg-none">
                                      <div
                                        class="slide-box icons-center-slider mt-60 mt-"
                                        style="width: 65em; margin-left: -16em">
                                        <img
                                          src="../../../../assets/app-assets/images/Sindicatos/tecnologo.png"
                                          alt="SINDICATOS DOS TECNOLOGOS" />
                                      </div>
                                    </div>
                                    <div class="d-none d-sm-block d-md-none">
                                      <div class="slide-box icons-center-slider mt-60">
                                        <img
                                          src="../../../../assets/app-assets/images/Sindicatos/tecnologo.png"
                                          alt="SINDICATOS DOS TECNOLOGOS" />
                                      </div>
                                    </div>
                                    <div
                                      class="d-block d-sm-none"
                                      style="width: 217px; margin: auto; margin-top: 111px">
                                      <img
                                        src="../../../../assets/app-assets/images/Sindicatos/tecnologo.png"
                                        alt="SINDICATOS DOS TECNOLOGOS"
                                        class="d-block" />
                                    </div>
                                  </div>
                                </div>
                                <div class="icon-w-mobile-civil">
                                  <a
                                    href="#carousel-estudante"
                                    role="button"
                                    data-slide="prev"
                                    class="carousel-control-prev">
                                    <span
                                      aria-hidden="true"
                                      class="carousel-control-prev-icon icon-left-civil-moible icon-arow-style"></span>
                                    <span class="sr-only">Previous</span>
                                  </a>
                                  <a
                                    href="#carousel-estudante"
                                    role="button"
                                    data-slide="next"
                                    class="carousel-control-next">
                                    <span
                                      aria-hidden="true"
                                      class="carousel-control-next-icon icon-rigth-civil-moible icon-arow-style"></span>
                                    <span class="sr-only">Next</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- VERTICAL ABAS END -->
    </section>
    <!-- TABS PARCEIROS E ENTIDADES -->

    <!-- SOMOS   A GEIA -->
    <section class="service-section section-gap-100" id="about-geia">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-6 col-md-10">
            <div class="faq-image text-center text-lg-left mb-md-50">
              <div id="carousel-sobre-geia" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner" role="listbox">
                  <div class="carousel-item">
                    <img src="../../../../assets/app-assets/images/fotografias/fachada-geia.png" alt="First slide" />
                  </div>
                  <div class="carousel-item">
                    <img src="../../../../assets/app-assets/images/fotografias/ambiente.png" alt="Second slide" />
                  </div>
                  <div class="carousel-item active">
                    <img src="../../../../assets/app-assets/images/fotografias/todos.png" alt="Third slide" />
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carousel-sobre-geia" role="button" data-slide="prev">
                  <button class="slick-arrow cursor-pointer prev-arrow prev arrow-slider">
                    <i class="fa fa-angle-left"></i>
                  </button>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carousel-sobre-geia" role="button" data-slide="next">
                  <button class="slick-arrow cursor-pointer prev-arrow prev arrow-slider">
                    <i class="fa fa-angle-right"></i>
                  </button>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-9 col-sm-11">
            <div class="faq-content pl-xl-5">
              <div class="section-heading">
                <span class="subt-title-left span-30px">Somos a sua</span>
                <h2 class="title-left" style="line-height: 1.1">Gestora de Benefícios</h2>
              </div>
              <p class="mt-1">
                Com mais de 24 anos de mercado, milhares de vidas beneficiadas e qualidade comprovada por nossos
                clientes:
                <br />
                <strong>a Géia é a melhor solução em gestão de benefícios.</strong>
                <br />
                Somos uma
                <strong>consultoria especializada</strong>
                em vendas de planos de saúde, planos odontológicos e seguros de todas as categorias (vida, auto,
                previdência privada, bike, equipamentos, entre outros). Atuamos também como Administradora de
                Benefícios, assessorando na administração de benefícios, com faturamento, cobrança, relacionamento com o
                cliente, gerenciamento de risco e programa de atenção a saúde.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- SOMOS A GEIA -->

    <!-- <MISAO VISAO VALORES START  -->
    <section class="services-section section-gap mt-visao-moible">
      <div class="container">
        <div class="row service-loop justify-content-center">
          <div class="col-lg-4 col-md-6 col-sm-10">
            <div class="mt-30">
              <div class="image">
                <img src="../../../../assets/app-assets/images/ilustracao/missao.png" alt="Geia Misao" />
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-10">
            <div class="margin-img mt-30">
              <div class="image">
                <img class="" src="../../../../assets/app-assets/images/ilustracao/visao.png" alt="Geia Visao" />
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-9">
            <div class="mt-30">
              <div class="image">
                <img src="../../../../assets/app-assets/images/ilustracao/valores.png" alt="Geia Valores" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <MISAO VISAO VALORES  END-->

    <!-- INTEGRIDADE E COMPLANCE START -->
    <section class="about-section mt-section-complance-mobile" id="integridade-compliance">
      <div class="container">
        <div class="row justify-content-center justify-content-lg-between align-items-center">
          <div class="container-fluid col-lg-4 col-md-4 d-none d-sm-none d-md-none d-lg-block">
            <div class="about-img" style="width: 80% !important">
              <img class="" src="../../../../assets/app-assets/images/fotografias/compliance.png" alt="Image" />
            </div>
          </div>
          <div class="col-rem-pading d-sm-block d-md-block d-lg-none">
            <div>
              <img class="" src="../../../../assets/app-assets/images/fotografias/mobile-complace.png" alt="Image" />
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12">
            <div class="about-content mt-md-50">
              <div class="section-heading mt-5">
                <span class="subt-title-left span-30px">Programa de</span>
                <h2 class="title-left" style="line-height: 1.1">Integridade e Compliance</h2>
              </div>
              <p class="mt-1">
                A Géia garante a transparência e zelo na regularidade de sua atuação, além de adotar uma postura de
                tolerância zero para corrupção, fraudes e atos ilícitos. Este compromisso é um dos pilares de nossa
                cultura corporativa em bases éticas e sustentáveis. Nosso programa de integridade e Compliance, atua
                firmemente em nossa instituição, norteando o desenvolvimento de políticas e normas.
              </p>

              <ul class="row container">
                <div class="col-lg-5 col-md-6 col-sm-12 mt-1">
                  <li class="wow fadeInUp">
                    <div>
                      <ul>
                        <li class="row mb-2">
                          <a
                            href="https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fgeiaerp.blob.core.windows.net%2Ferpgeianew%2FComplianceInstitucional%2F18.1.4-Politica-de-privacidade-de-dados%2520-%2520Versa%25CC%2583o%2520Site.docx&wdOrigin=BROWSELINK"
                            target="_blank">
                            <i class="bold-preto-600 mt-1 item-justify-line">
                              <img
                                width="20px"
                                src="../../../../assets/app-assets/images/icones-geia/icon-doc-compliance.png"
                                alt="CÓDIGO DE ÉTICA" />
                              CÓDIGO DE ÉTICA
                            </i>
                          </a>
                        </li>
                        <li class="row mb-2">
                          <a
                            href="https://geiaerp.blob.core.windows.net/erpgeianew/ComplianceInstitucional/Organograma Géia.pdf"
                            target="_blank">
                            <i class="bold-preto-600 mt-1 item-justify-line">
                              <img
                                width="20px"
                                src="../../../../assets/app-assets/images/icones-geia/icon-doc-compliance.png"
                                alt="QUADRO DE TRANSPARÊNCIA" />
                              QUADRO DE TRANSPARÊNCIA
                            </i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </div>
                <div class="col-lg-7 col-md-8 col-sm-12 mt-1">
                  <li class="row mb-2">
                    <a
                      href="https://geiaerp.blob.core.windows.net/erpgeianew/ComplianceInstitucional/Politica de Gestao de Risco Geia.pdf"
                      target="_blank">
                      <i class="bold-preto-600 mt-1 item-justify-line">
                        <img
                          width="20px"
                          src="../../../../assets/app-assets/images/icones-geia/icon-doc-compliance.png"
                          alt="POLÍTICA DE GESTÃO DE RISCOS" />
                        POLÍTICA DE GESTÃO DE RISCOS
                      </i>
                    </a>
                  </li>

                  <li class="row mb-2">
                    <a
                      href="https://geiaerp.blob.core.windows.net/erpgeianew/ComplianceInstitucional/Politica de Governança_Finalizada.pdf"
                      target="_blank">
                      <i class="bold-preto-600 mt-1 item-justify-line">
                        <img
                          width="20px"
                          src="../../../../assets/app-assets/images/icones-geia/icon-doc-compliance.png"
                          alt="POLÍTICA DE GOVERNANÇA CORPORATIVA" />
                        POLÍTICA DE GOVERNANÇA CORPORATIVA
                      </i>
                    </a>
                  </li>
                </div>

                <p>
                  Nosso
                  <span class="bold-azul bold-azul-geia">Canal de Denúncia</span>
                  pode ser utilizado por qualquer pessoa, de dentro ou fora da Géia, que tenha conhecimento ou suspeita
                  de violação ao nosso Código de Conduta, nossas políticas e diretrizes internas. O canal garante total
                  sigilo e confidencialidade.
                </p>
              </ul>
              <div class="container-fluid description-header row mb-3">
                <div class="row col-lg-7 col-md-12 col-sm-12 mt-2">
                  <h3 class="widget-title bold-preto-600" style="text-wrap: balance">
                    ESTAMOS
                    <i class="bold-azul bold-azul-geia font-normal">PREPARADOS</i>
                    PARA TE OUVIR E TE AUXILIAR.
                  </h3>
                </div>

                <div class="row col-auto col-lg-6 col-md-12 col-sm-12 mt-2">
                  <a data-toggle="modal" data-target="#modalCanalDenuncia">
                    <button type="submit" class="cursor-pointer template-btn template-btn-primary">
                      <i class="fa fa-bullhorn fa-3x"></i>
                      CANAL DE DENÚNCIAS
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- INTEGRIDADE E COMPLANCE END -->

    <!-- MODAL CANAL DENUNCIA START -->
    <div
      class="modal fade"
      id="modalCanalDenuncia"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal"
      aria-hidden="true">
      <div class="modal-dialog modal-lg section-gap-100">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row modal-body">
            <div class="col-lg-4 col-md-10">
              <div class="about-img" style="width: 323px">
                <img
                  class="border-radius-img col-rem-pading"
                  src="../../../../assets/app-assets/images/ilustracao/complicance.png"
                  alt="Image" />
              </div>
            </div>
            <div class="col-lg-8 col-md-10 col-sm-8" style="padding-left: 54px; padding-right: 0px">
              <div class="section-heading">
                <span class="subt-title-left">SEJA BEM-VINDO AO</span>
                <h6 class="title-left" style="line-height: 1.1; font-size: 19px">
                  CANAL DE ATENDIMENTO DE
                  <span class="bold-preto-700" style="line-height: 1.8">
                    DENÚNCIAS, RECLAMAÇÕES E SUGESTÕES DA GÉIA.
                  </span>
                </h6>
              </div>
              <p>
                <span class="title mt-1 bold-preto-600" style="font-size: 14px">
                  O QUE VOCÊ PODE FAZER NESTE CANAL:
                </span>
              </p>

              <div class="col-xl-12 col-lg-6 col-md-8 col-sm-10">
                <div class="about-content mt-md-50">
                  <ul class="container-fluid row mt-1">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <div class="contact-us">
                        <div class="section-heading text-center mb-40">
                          <div class="section-heading mb-20">
                            <div class="text-center">
                              <div class="icon mb-1">
                                <div data-wow-delay="0.5s" class="single-img wow fadeInLeft">
                                  <img
                                    width="40px"
                                    src="../../../../assets/app-assets/images/icones-geia/compliance doc.png"
                                    alt="compliance doc" />
                                </div>
                              </div>
                            </div>
                            <h5 style="font-size: 13px" class="bold-preto-600 mt-1 cursor-pointer">
                              Relatos de comportamentos incoerentes com o nosso Código de Ética e Conduta ou com as leis
                              vigentes.
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <div class="contact-us">
                        <div class="section-heading text-center mb-40">
                          <div class="section-heading mb-20">
                            <div class="text-center">
                              <div class="icon mb-1">
                                <div data-wow-delay="0.5s" class="single-img wow fadeInLeft">
                                  <img
                                    width="55px"
                                    src="../../../../assets/app-assets/images/icones-geia/compliance-lines.png"
                                    alt="compliance lines" />
                                </div>
                              </div>
                            </div>
                            <h5 style="font-size: 13px" class="bold-preto-600 mt-1">
                              Sugestões para melhorias dos nossos sistemas, controles e ambientes de trabalho.
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-1" style="text-align: center">
            <p style="font-size: 14px">
              <span class="title bold-preto-600">
                USE O MENU ABAIXO PARA FAZER SUA
                <b>DENÚNCIA, FAZER SUA SUGESTÃO OU TIRAR SUA DÚVIDA</b>
              </span>
              .
            </p>
          </div>
          <div class="modal-footer">
            <a
              href="https://forms.office.com/pages/responsepage.aspx?id=68I-toTCo0G0AceSI4tY06E_aCBV2RxAm8QwDfSVCt9UMFZCOFlITUtHRDc3NzdTNTVYWTM4STRINS4u"
              target="_blank"
              class="btn template-btn-white text-white template-btn-primary btn-danger round box-shadow-5">
              DENÚNCIE
            </a>
            <a>
              <button
                (click)="navigateToSection('contato')"
                data-dismiss="modal"
                class="btn template-btn-white template-btn-primary round box-shadow-4 text-white">
                DÚVIDAS
              </button>
            </a>

            <button
              (click)="navigateToSection('contato')"
              data-dismiss="modal"
              class="btn template-btn-white template-btn-primary round box-shadow-4 text-white">
              SUGESTÕES
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL CANAL DENUNCIA END -->

    <!-- PROJETOS E PROGRAMAS START -->
    <section
      id="projetos-e-programas"
      class="feature-medicine-section bg-color-grey"
      style="background: #cecece 0% 0% no-repeat padding-box">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-5 col-md-10 order-lg-last">
            <div class="tile-gallery-three">
              <div class="image-one">
                <img src="../../../../assets/app-assets/images/ilustracao/programas e projetos.png" alt="Image" />
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-8 col-sm-10">
            <div class="feature-content pr-xl-5 mt-md-50">
              <div class="section-heading mt-5">
                <span class="subt-title-left span-30px">Projetos e</span>
                <h2 class="title-left" style="line-height: 1.1">Programas</h2>
              </div>
              <p class="mt-1">
                <i class="bold-azul font-normal">
                  Saúde e segurança fazem parte do nosso vocabulário e da nossa rotina diária.
                </i>
                Desenvolvemos programas específicos para criarmos um ambiente colaborativo de prevenção e promoção da
                saúde dos nossos colaboradores e de cuidado com o nosso espaço em comum, sempre pensando no impacto
                ambiental das nossas ações. 
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row mx-auto my-auto">
          <div id="myCarousel" class="carousel slide desktopCarouselCard" data-ride="carousel">
            <div class="carousel-inner justify-content-center latest-blog-loop" role="listbox">
              <div class="carousel-item py-5 active">
                <div class="row mx-auto my-auto">
                  <div class="container">
                    <div class="row" style="flex-wrap: unset !important">
                      <div class="row" style="flex-wrap: unset !important">
                        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                          <div class="card shadow-card card-not-respo-2">
                            <img
                              class="card-img-top img-fluid mt-2 mx-auto"
                              src="../../../../assets/app-assets/images/logo/internos/Geiafit.png"
                              alt="GÉIAFIT"
                              style="width: 50%" />
                            <div class="card-body d-flex flex-column">
                              <p class="card-text text-left" style="inline-size: 101%">
                                Programa de incentivo à atividade física e qualidade de vida, com bonificação mensal
                                para a participação dos colaboradores. Exercícios regulares, meditação guiada e
                                participação nas corridas de rua em SP motivam o nosso dia a dia e reduzem o índice de
                                estresse e doenças ocupacionais.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                          <div class="card shadow-card card-not-respo-2">
                            <img
                              class="card-img-top mx-auto img-fluid mt-4"
                              src="../../../../assets/app-assets/images/logo/internos/ecogeia.png"
                              alt="ECOGÉIA"
                              style="width: 50%" />
                            <div class="card-body d-flex flex-column">
                              <p class="card-text text-left" style="inline-size: 101%">
                                Contribuímos para a melhoria do meio ambiente através de práticas diárias de
                                sustentação:
                                <br />
                                •Substituição de copos descartáveis por canecas;
                                <br />
                                •Separação do lixo para reciclagem;
                                <br />
                                •Ações de reutilização da água de chuva.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                          <div class="card shadow-card card-not-respo-2">
                            <img
                              class="card-img-top mx-auto img-fluid mt-5"
                              src="../../../../assets/app-assets/images/logo/internos/geiaon.png"
                              alt="GÉIAON"
                              style="width: 50%" />
                            <div class="card-body d-flex flex-column">
                              <p class="card-text text-left" style="inline-size: 101%">
                                Baseado na idéia de streaming, desenvolvemos conteúdos em vídeos, separados em séries e
                                temporadas para facilitar a compreensão dos nossos produtos e do nosso universo Géia.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="carousel-item py-5">
                <div class="row mx-auto my-auto">
                  <div class="container">
                    <div class="row" style="flex-wrap: unset !important">
                      <div class="row" style="flex-wrap: unset !important">
                        <div class="col-lg-4 mb-3 mx-auto d-flex align-items-stretch">
                          <div class="card shadow-card card-not-respo-1">
                            <img
                              class="card-img-top mx-auto img-fluid mt-5"
                              src="../../../../assets/app-assets/images/logo/internos/uniGeia.png"
                              alt="UNIGÉIA"
                              style="width: 50%" />
                            <div class="card-body d-flex flex-column">
                              <p class="card-text text-left" style="inline-size: 101%">
                                Nossa Universidade Géia visa a formação e desenvolvimento dos profissionais diretos e
                                indiretos, que prestam serviços a Géia. Um espaço de informação, eventos institucionais,
                                cursos e treinamentos.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                          <div class="card shadow-card card-not-respo-1">
                            <img
                              class="card-img-top mx-auto img-fluid mt-2"
                              src="../../../../assets/app-assets/images/logo/internos/conviteBem.png"
                              alt="CONVITE DO BEM"
                              style="width: 30%" />
                            <div class="card-body d-flex flex-column">
                              <p class="card-text text-left" style="inline-size: 101%">
                                Projeto que visa a doação, compartilhamento e sustentabilidade. Em um espaço aberto ao
                                público, todos podem participar deixando objetos/alimentos para contribuir com o próximo
                                e/ou pegando o que precisar.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                          <div class="card shadow-card card-not-respo-1">
                            <img
                              class="card-img-top mx-auto img-fluid mt-2"
                              src="../../../../assets/app-assets/images/logo/internos/nutriGeia.png"
                              alt="NUTRIGÉIA"
                              style="width: 30%" />
                            <div class="card-body d-flex flex-column">
                              <p class="card-text text-left" style="inline-size: 101%">
                                Contamos com uma equipe de especialistas que nos ensinam como ter hábitos alimentares
                                mais saudáveis, para prevenção e promoção da saúde, através da alimentação, além de
                                dicas de cardápios e receitas simples para colocarmos em prática na nossa rotina.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a
              class="carousel-control-prev icon-slider-mobile"
              href="#myCarousel"
              data-slide="prev"
              style="height: 50%; margin-top: 10%">
              <span class="icon-slider-desktop-esquerdo icon-slider-style carousel-control-prev-icon"></span>
            </a>

            <a
              class="carousel-control-next"
              href="#myCarousel"
              data-slide="next"
              style="height: 50%; margin-top: 10%; margin-right: clamp(-20px, -10px, -19px)">
              <span class="icon-slider-desktop-direito icon-slider-style carousel-control-next-icon"></span>
            </a>
          </div>

          <div id="myCarouselMobile" class="carousel slide mobileCarouselCards" data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                  <div class="card shadow-card card-not-respo-2">
                    <img
                      class="card-img-top img-fluid mt-2 mx-auto"
                      src="../../../../assets/app-assets/images/logo/internos/Geiafit.png"
                      alt="GÉIAFIT"
                      style="width: 50%" />
                    <div class="card-body d-flex flex-column">
                      <p class="card-text text-left" style="inline-size: 101%">
                        Programa de incentivo à atividade física e qualidade de vida com bonificação mensal para a
                        participação dos colaboradores. Exercícios regulares, meditação guiada e participação nas
                        corridas de rua em SP motivam o nosso dia a dia e reduzem o índice de estresse e doenças
                        ocupacionais.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                  <div class="card shadow-card card-not-respo-2">
                    <img
                      class="card-img-top mx-auto img-fluid mt-4"
                      src="../../../../assets/app-assets/images/logo/internos/ecogeia.png"
                      alt="ECOGÉIA"
                      style="width: 50%" />
                    <div class="card-body d-flex flex-column">
                      <p class="card-text text-left" style="inline-size: 101%">
                        Contribuímos para a melhoria do meio ambiente através de práticas diárias de sustentação:
                        <br />
                        •Substituição de copos descartáveis por canecas;
                        <br />
                        •Separação do lixo para reciclagem;
                        <br />
                        •Ações de reutilização da água de chuva.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                  <div class="card shadow-card card-not-respo-2">
                    <img
                      class="card-img-top mx-auto img-fluid mt-5"
                      src="../../../../assets/app-assets/images/logo/internos/geiaon.png"
                      alt="GÉIAON"
                      style="width: 50%" />
                    <div class="card-body d-flex flex-column">
                      <p class="card-text text-left" style="inline-size: 101%">
                        Baseado na idéia de streaming, desenvolvemos conteúdos em vídeos, separados em séries e
                        temporadas, para facilitar a compreensão dos nossos produtos e do nosso universo Géia.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="col-lg-4 mb-3 mx-auto d-flex align-items-stretch">
                  <div class="card shadow-card card-not-respo-1">
                    <img
                      class="card-img-top mx-auto img-fluid mt-5"
                      src="../../../../assets/app-assets/images/logo/internos/uniGeia.png"
                      alt="UNIGÉIA"
                      style="width: 50%" />
                    <div class="card-body d-flex flex-column">
                      <p class="card-text text-left" style="inline-size: 101%">
                        Nossa Universidade Géia visa a formação e desenvolvimento dos profissionais diretos e indiretos,
                        que prestam serviços a Géia. Um espaço de informação, eventos institucionais, cursos e
                        treinamentos.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                  <div class="card shadow-card card-not-respo-1">
                    <img
                      class="card-img-top mx-auto img-fluid mt-2"
                      src="../../../../assets/app-assets/images/logo/internos/conviteBem.png"
                      alt="CONVITE DO BEM"
                      style="width: 30%" />
                    <div class="card-body d-flex flex-column">
                      <p class="card-text text-left" style="inline-size: 101%">
                        Projeto que visa a doação, compartilhamento e sustentabilidade. Em um espaço aberto ao público,
                        todos podem participar deixando objetos/alimentos para contribuir com o próximo e/ou pegando o
                        que precisar.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="col-lg-4 mb-3 d-flex align-items-stretch">
                  <div class="card shadow-card card-not-respo-1">
                    <img
                      class="card-img-top mx-auto img-fluid mt-2"
                      src="../../../../assets/app-assets/images/logo/internos/nutriGeia.png"
                      alt="NUTRIGÉIA"
                      style="width: 30%" />
                    <div class="card-body d-flex flex-column">
                      <p class="card-text text-left" style="inline-size: 101%">
                        Contamos com uma equipe de especialistas que nos ensinam como ter hábitos alimentares mais
                        saudáveis, para prevenção e promoção da saúde, através da alimentação, além de dicas de
                        cardápios e receitas simples para colocarmos em prática na nossa rotina.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <a
                class="carousel-control-prev icon-slider-mobile container"
                href="#myCarouselMobile"
                data-slide="prev"
                style="height: 50%; margin-top: 10%">
                <span
                  class="icon-slider-desktop-esquerdo icon-slider-style carousel-control-prev-icon container"
                  style="margin-right: clamp(91px, 92px, 95px)"></span>
              </a>

              <a
                class="carousel-control-next"
                href="#myCarouselMobile"
                data-slide="next"
                style="height: 50%; margin-top: 10%">
                <span class="icon-slider-desktop-direito icon-slider-style carousel-control-next-icon container"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- PROJETOS E PROGRAMAS END -->
    <!-- <blog -->
    <app-blog></app-blog>

    <!--RELACIONAMENTO CONTINUO-->

    <div id="contato">
      <app-email-contact></app-email-contact>
    </div>

    <!-- footer START -->
    <app-portal-footer></app-portal-footer>
    <app-nexus-chat></app-nexus-chat>

    <!-- Tag Linkedin -->
    <script type="text/javascript">
      _linkedin_partner_id = '7790985';
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    </script>
    <script type="text/javascript">
      (function (l) {
        if (!l) {
          window.lintrk = function (a, b) {
            window.lintrk.q.push([a, b]);
          };
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName('script')[0];
        var b = document.createElement('script');
        b.type = 'text/javascript';
        b.async = true;
        b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    </script>
    <noscript>
      <img
        height="1"
        width="1"
        style="display: none"
        alt=""
        src="
    https://px.ads.linkedin.com/collect/?pid=7790985&fmt=gif" />
    </noscript>
  </body>
</html>
